import { merge } from 'lodash';
import Card from './Card';
import Input from './Input';

export default function ComponentsStyle(theme) {
  return merge(Card(theme), Input(theme));
}
